export const getStyles = (headlineSubline: string): Record<string, any> => ({
  wrapperStyles: 'flex w-full flex-col px-8 xl:px-44',
  prelineWrapper: 'pt-24 xl:pt-32',
  prelineStyles: 'text-left xl:text-center',
  headlineWrapper: 'pt-6 pb-16 xl:pb-20',
  headlineStyles: `text-36 md:text-44 leading-48 md:leading-56 ${headlineSubline} text-left xl:text-center`
})
